import * as Redux from "redux";
import storage from "redux-persist/lib/storage";

import { AnalyticsActions } from "src/core/analytics/store/analytics.actions";
import * as AT from "src/core/analytics/store/analytics.constants";

import type { IMetric } from "../api/analytics.api";

export interface IAnalyticsStore {
  metrics: IMetric[] | null;
  lastFetch: Date | null;
}

const initialState: IAnalyticsStore = {
  metrics: null,
  lastFetch: null
};

export const analyticsReducer: Redux.Reducer<IAnalyticsStore> = (
  state: IAnalyticsStore = initialState,
  action: AnalyticsActions
): IAnalyticsStore => {
  switch (action.type) {
    case AT.PURGE_ANALYTICS:
      return initialState;

    case AT.SET_METRICS:
      return {
        ...state,
        metrics: action.metrics,
        lastFetch: new Date()
      };

    default:
      return state;
  }
};

export const analyticsPersistConfig = {
  key: "analytics",
  storage,
  blacklist: [ "" ]
};
